
import React, { Component } from 'react';
import { FormControl, Button, ButtonToolbar, FormGroup, Form } from 'react-bootstrap'
// import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import ReactPaginate from 'react-paginate';
import { Box } from 'reactjs-admin-lte'
// import PODocStore from '../../stores/PODocStore'
import WorkdocStore from '../../stores/WorkdocStore'
import InsurerEditModal from './InsurerEditModal'
import withSizes from 'react-sizes';
import ReportMobileTable from '../report/ReportMobileTable'
import IframeModal from 'component/element/IframeModal'
import { Checkbox } from 'react-icheck'

/* const mock = [
  {
  address: "25 ถนนสาทรใต้ แขวงทุ่งมหาเมฆ เขตสาทร กรุงเทพฯ 10120",
  bf_insurer_id: "5",
  email: "",
  emcs: "",
  fax: "0-2502-2911",
  name: "บริษัท ทดสอบ จำกัด (มหาชน)",
  out_of_business: "0",
  short_name: "กมลประกันภัย",
  tax_no: "",
  tel: "0-2502-2111 ",
  website: "www.testinsurance.com"
},
{
  address: "สำนักงานใหญ่ 421, 423 ถ.บอนด์สตรีท ต.บางพูด อ.ปากเกร็ด จ.นนทบุรี 11120 ",
  bf_insurer_id: "6",
  email: "",
  emcs: "",
  fax: "0-2502-2955",
  name: "บริษัท กมลประกันภัย จำกัด (มหาชน)",
  out_of_business: "0",
  short_name: "กมลประกันภัย",
  tax_no: "",
  tel: "0-2502-2999 ",
  website: "www.kamolinsurance.com"
}
]
 */
class InsurerPage extends Component {

  constructor(...args) {
    super(...args)
    this.itemNumPerPage = 20
    this.state = {
      loading: false,
      showEdit: false,
      showHistory: false,
      curPage: 0,
      // pageCount: 0,
      query: '',
      catOptions: [],
      tableData: [],
      isPrint:false,
      check_itemlist:[],
      isCheckAll:false
    }
  }

  componentDidMount() {
    this.loadInsurerList('', this.state.curPage)
  }

  loadInsurerList(query, pageNo) {
    if(typeof pageNo === 'undefined') pageNo = 0
    
    this.setState({
      loading: true
    })
    let {check_itemlist} = this.state 
    WorkdocStore.loadInsurerList(query, pageNo, this.itemNumPerPage, (result) => {
      check_itemlist = result.data.map((item,index)=>{
        return {id:item.bf_insurer_id,isCheck:false}
      })
      this.setState(()=>({
        check_itemlist: check_itemlist,
        query: query,
        curPage: pageNo,
        tableData: result.data,
        total_count: result.total_count, 
        loading: false
      }))
    })
  }

  checkAll() {
    let {check_itemlist} = this.state
    let find = check_itemlist.findIndex(x=>x.isCheck===false)
    let check = false
    if (find===-1)
      check = true
    return check
  }

  checkHas() {
    let {check_itemlist} = this.state
    let find = check_itemlist.findIndex(x=>x.isCheck===true)
    let check = false
    if (find!==-1)
      check = true
    return check
  }

  onCheckboxChange(index) {
    let {check_itemlist} = this.state
    if (check_itemlist[index].isCheck)
      check_itemlist[index].isCheck = false
    else
      check_itemlist[index].isCheck = true

    this.setState({check_itemlist:check_itemlist,isCheckAll:this.checkAll(),isPrint:this.checkHas()})
  }

  onCheckboxAllChange() {
    let {isCheckAll,check_itemlist} = this.state
    let new_list = []
    if (isCheckAll) {
      new_list = check_itemlist.map((item,index)=>{
        item.isCheck = false
        return item
      })
      this.setState({isCheckAll:false})
    } else {
      new_list = check_itemlist.map((item,index)=>{
        item.isCheck = true
        return item
      })
      this.setState({isCheckAll:true})
    }
    this.setState({check_itemlist:new_list,isPrint:this.checkHas()})
  }

  onHide() {

  }

  onTextChange(e) {
    let query = e.target.value
    if (typeof query !== 'undefined' && query.length > 2 || query.length === 0) 
      this.loadInsurerList(query);
    else
      this.setState({ query: query })
    
  }

  onNewClick() {
    this.refs.insuritemedit.loadItemcode(null)
    this.setState({ showEdit: true })
  }

  onEditClick(item) {
    this.refs.insuritemedit.loadItemcode(item)
    this.setState({ showEdit: true })
  }

  onHistoryClick(item) {
    this.refs.customerHist.loadHistory(item)
    this.setState({ showHistory: true })
  }

  onRowClick(item) {

    //this.props.onSelect(item)
    if (typeof this.props.onSelectItem !== 'undefined')
      this.props.onSelectItem(item)
  }

  onClearClick() {
    
    // console.log('clear click query : ', this.state.query)
    this.loadInsurerList('', 0)
  }

  onAfterSubmit(postData) {
    this.onClearClick()

    if(this.props.onChange!==undefined){
      this.props.onChange()
    }
  }

  onPageChange(page) {
    // console.log('Change page to ', page)
    let { query } = this.state

    this.loadInsurerList(query, page.selected)

    this.setState({ curPage: page.selected })
  }

  onPrintClick() {
    let {check_itemlist} = this.state
    let doc_nos = []

    check_itemlist.forEach(function(item,index) {
      if (item.isCheck) {
        doc_nos.push(item.id)
      }
    })

    let doc_no = doc_nos.join()
    let file = 'PrintShippingLabel&idlist='+doc_no+'&doc=insurer'
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = './?startPage='+file
    } else{
      url = './pdf/v2/?startPage='+file
    }
    this.refs.iframe.loadUrl(url)
  }

  renderSearch() {
    let { query, isPrint } = this.state
    let { showNew, isMobile } = this.props
    if (typeof showNew == 'undefined') {
      showNew = true
    }
    return (
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup controlId="formInlineEmail" style={{width:(isMobile?'100%':'30%')}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)} style={{width:'100%'}} />
        </FormGroup>{' '}
        <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>{' '}
        <Button style={{display:showNew?'':'none'}} bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มบริษัทประกัน</Button>{' '}
        {isPrint?<Button bsStyle='danger' onClick={this.onPrintClick.bind(this)}><FontAwesome name='print' />&nbsp;พิมพ์ใบจ่าหน้าซอง</Button>
        :''}
      </Form>
    )
  }

  renderRowData() {
    let { tableData, check_itemlist } = this.state
    return tableData.map((item, index) => (
      <tr key={index}>
        <td className='text-center'>
          <Checkbox
            onChange={this.onCheckboxChange.bind(this,index)}
            checked={check_itemlist[index].isCheck}
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            label={''}
          >
          </Checkbox>
        </td>
        <td onClick={this.onRowClick.bind(this, item)}>{item.name}</td>
        <td onClick={this.onRowClick.bind(this, item)}>{item.address}</td>
        <td onClick={this.onRowClick.bind(this, item)} >{item.tel}</td>
        <td className='text-center'>
          <ButtonToolbar>

            <Button onClick={this.onEditClick.bind(this, item)}>แก้ไข</Button>
          </ButtonToolbar>
        </td>
      </tr>
    ))
  }

  renderSearchResult() {
    let {isCheckAll} = this.state
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th className='text-center' style={{ width: '50px' }}>
                <Checkbox
                  onChange={this.onCheckboxAllChange.bind(this)}
                  checked={isCheckAll}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={''}
                >
                </Checkbox>
              </th>
              <th style={{ width: '300px' }}>บริษัท</th>
              <th>ที่อยู่</th>
              <th style={{ width: '150px' }}>เบอร์โทร</th>
              <th style={{ width: '150px' }}>ดูประวัติ/แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }


  renderPaging() {
    if (this.state.total_count > 0) {
      return (
        <div className="commentBox">
          <ReactPaginate
            previousLabel={"ก่อนหน้า"}
            nextLabel={"ถัดไป"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.total_count / this.itemNumPerPage}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} 
            forcePage={this.state.curPage}  
          />
        </div>
      );
    } else {
      return (<div />)
    }
  }

  onRowWorkClick(item,items) {
    this.onRowClick(items)
  }

  renderMobileTable(){
    let {tableData} = this.state
    let fieldMap = {title:'name',amount:'tel',sub_title:'address',date:'',status:'',sub_status:''}
    return(
      <div>
        <ReportMobileTable
          itemlist={tableData}
          fieldMap={fieldMap}
          keyIndex={'bf_insurer_id'}
          numberFormat={false}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  render() {
    let { isMobile } = this.props
    let { loading, showEdit, showHistory, catOptions } = this.state
    return (
      <div>
        <Box loading={loading}>
          <Box.Body>
            {this.renderSearch()}
            {isMobile?this.renderMobileTable():this.renderSearchResult()}
            {this.renderPaging()}
          </Box.Body>
        </Box>

        <InsurerEditModal ref={'insuritemedit'} show={showEdit}
          catOptions={catOptions}
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onHide={() => { this.setState({ showEdit: false }) }} />
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />  
      </div>
    )
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default InsurerPage = withSizes(mapSizesToProps)(InsurerPage);





// WEBPACK FOOTER //
// ./src/view/insurer/InsurerPage.js